import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setListAttendeesSearch = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<string>((state, action) => {
    state.listAttendees.search = action.payload;
    state.listAttendees.page = 1;
  });
